<script>
import { isEmpty, cloneDeep } from 'lodash';
import FileApi from '@/api/common/file';

import WDeviceListView from '@/views/config/group/netdevice/components/DeviceListView';
import MapAPI from '@/api/topologymap/common';

export default {
  name: 'WTopologymapDeviceListView',
  extends: WDeviceListView,
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    loadStore(reload) {
      if (this.active && this.activeTab === this.$options.name) {
        if (reload) {
          this.columns = [];
          this.$refs.devicelistTable.clearFilter();
          this.columns = cloneDeep(this.expandColumns);
          this.$nextTick(() => {
            this.getConfigTemplateColums();
          });
        } else if (this.tableType === 'expand') {
          this.columns = [];
          this.columns = cloneDeep(this.expandColumns);
          this.getConfigTemplateColums();
        }
        const tableParams = this.$refs.devicelistTable.getParameter();
        const params = {
          ...tableParams,
          customerId: this.customerId,
          tableType: this.tableType,
          mapId: this.$store.getters.getCurrentMapId,
        };
        MapAPI
          .getNetdeviceConfigInfoDeviceList(params)
          .then((result) => {
            if (result.data.success === true) {
              this.tableData = result.data.data;
              this.tableTotal = result.data.total;
            }
          });
      }
    },
    onClickExportExcel() {
      const tableParams = this.$refs.devicelistTable.getParameter();
      const params = {
        ...tableParams,
        customerId: this.customerId,
        tableType: this.tableType,
        mapId: this.$store.getters.getCurrentMapId,
      };
      MapAPI.getNetdeviceConfigInfoDeviceListExcelName(params).then((response) => {
        if (response.data.success && !isEmpty(response.data.data)) {
          FileApi.downloadExportedExcelFile(response.data.data);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/perfoper/config/components/netdevice/TopologymapDeviceListView.vue